export enum ChannelEvent {
  'CHANNEL_ADD_SLICE' = 'CHANNEL_ADD_SLICE',
  'CHANNEL_UPDATE_SLICE' = 'CHANNEL_UPDATE_SLICE',
  'CHANNEL_DELETE_SLICE' = 'CHANNEL_DELETE_SLICE',
  'CHANNEL_DELETE_CHANNEL' = 'CHANNEL_DELETE_CHANNEL',
  'CHANNEL_UPDATE_CHANNEL' = 'CHANNEL_UPDATE_CHANNEL',
  'CHANNEL_UPDATE_CHANNEL_VOL' = 'CHANNEL_UPDATE_CHANNEL_VOL',
  'CHANNEL_UPDATE_CHANNEL_PAN' = 'CHANNEL_UPDATE_CHANNEL_PAN',
}
